<svelte:options runes={true} />

<script lang="ts">
	interface Props {
		hint?: string;
		handleSignIn: () => void;
	}
	import MainSignInButton from './MainSignInButton.svelte';
	import TitleGraphic from './TitleGraphic.svelte';
	import { Card, CardContent } from './ui/card';

	let { hint = 'Please sign in or create an account to continue', handleSignIn }: Props = $props();
</script>

<div
	class="flex h-screen w-screen flex-col items-center justify-center bg-cover bg-center bg-no-repeat"
	style="background-image: url('/img/colored-bg-ios.png');"
>
	<div class="flex min-h-screen w-full items-center justify-center p-4 text-center">
		<Card class="w-full max-w-md">
			<CardContent>
				<TitleGraphic />
				<h3 class="mb-4 text-2xl font-bold text-white">{hint}</h3>
				<MainSignInButton {handleSignIn} />
			</CardContent>
		</Card>
	</div>
</div>
